module.exports = (__parcel__import__("fntmf")).then(() => parcelRequire('2ipug'));